import { FC } from 'react';
import MainLayout from '@layouts/main';
import { useAppContext } from '@lib/app-context';
import HomePage from '@components/home-page';

const Index: FC = () => {
  const { user, chosenCongress } = useAppContext({ redirect: true });

  if (chosenCongress == null) {
    return (
      <MainLayout
        alignment="top"
        panelled={false}
        restrictWidth={false}
        showSpinner
      />
    );
  }

  return (
    <MainLayout alignment="top" panelled={false} restrictWidth={true}>
      <HomePage user={user} congress={chosenCongress} />
    </MainLayout>
  );
};

export default Index;
